const request = require('request');
const config = require('./config');

var get = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/pedidoCompra/${filters.cd_fil}/${filters.cd_pedido}`,
        method: 'GET',
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
    });
  });
};

var getPedidos = (token) => {
    return new Promise((resolve,reject) => {
        request({
            headers: {
              'Content-Type': 'application/json',
              'User-Token': token
            },
            uri: config.URL_BACKEND+'/pedido',
            method: 'GET'
          }, (err, res, body) => {
            if (err) return reject(err);
            resolve(body)
          })
    })
}

var getPendentes = (token,filters) => {
    return new Promise((resolve,reject) => {
        request({
            headers: {
              'Content-Type': 'application/json',
              'User-Token': token
            },
            uri: config.URL_BACKEND+'/pedido/pendentes',
            method: 'GET',
            qs: filters
          }, (err, res, body) => {
            if (err) return reject(err);
            resolve({err: err, res: res, body: body});
          });
    });
};

var getPendentesAutomatico = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Authorization': config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '37693cfc748049e45d87b8c7d8b9aacd',
      },
      uri: config.API_NODE + '/orders',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body})
    });
  });
};

var getAgendados = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Authorization': config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '37693cfc748049e45d87b8c7d8b9aacd',
      },
      uri: config.API_NODE + '/orders',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var getDatasDisponiveis = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/pedido/datasDisponiveis',
      method: 'GET'
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var updatePedidos = (token,body) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/pedido/agendados',
      method: 'PUT',
      body: JSON.stringify(body)
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var postPendentes = (token,data,idFornecedor) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/pedido/pendentes/'+idFornecedor,
      method: 'POST',
      body: JSON.stringify(data)
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    })
  })
}


const getPedidoCompra = (token,params) => {
  return new Promise((resolve,reject) => {
      request({
        headers: {
          'Authorization': config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': 'b6d767d2f8ed5d21a44b0e5886680cb9',
        },
        uri: `${config.API_NODE}/orders/pdf?cdFil=${params.cd_fil}&purchaseOrderId=${params.nr_pc}${params.language === 'EN' ? '&english=S' : ''}`,
        method: 'GET',
      }, (err, res, body) => {
        if (err) return reject(err);
        const resultBodyJSON = JSON.parse(body)
        resolve({err: err, res: res, body: resultBodyJSON.base64String});
      });
  });
};

module.exports = {
  get:get,
  getPedidos:getPedidos,
  getPendentes:getPendentes,
  getAgendados:getAgendados,
  getDatasDisponiveis:getDatasDisponiveis,
  updatePedidos:updatePedidos,
  postPendentes:postPendentes,
  getPendentesAutomatico:getPendentesAutomatico,
  getPedidoCompra:getPedidoCompra
}